import React, { useMemo, useState } from 'react';
import styled, { css } from 'styled-components';
import { Chip } from '../../../elements/Chip';
import { Dropdown } from '../../../elements/Dropdown';
import { Icon } from '../../../elements/Icon';
import { DEFAULT_PAGE_SIZES } from '../types';
const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 16px 0 0;
`;
const PagesWrapper = styled.div `
  display: table;
`;
const Entries = styled(Chip) `
  --chip-pale: ${({ theme }) => theme.secondary.blendToBackground(150)};

  svg {
    display: inline-block;
    vertical-align: top;
    margin: 0 0 0 -4px;
  }
`;
const Button = styled.button `
  cursor: pointer;
  appearance: none;
  background: none;
  border: none;
  outline: none;
  margin: 0;
  padding: 6px;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 5px;
  color: ${({ theme }) => theme.secondary.background};
  background-color: ${({ theme }) => theme.secondary.blendToBackground(100)};
  transition:
    background-color 0.1s,
    color 0.1s;

  &:not(:disabled):hover {
    background-color: ${({ theme }) => theme.secondary.blendToBackground(150)};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.secondary.blendToBackground(600)};
    background-color: transparent;
  }

  svg {
    --icon-size: 16px;
    --icon-color: currentColor;
  }
`;
const Pages = styled.div `
  display: inline-flex;
  vertical-align: top;
  gap: 12px;
  margin: 0 12px;
`;
const Page = styled.button `
  cursor: pointer;
  appearance: none;
  background: none;
  border: none;
  outline: none;
  padding: 0;
  line-height: 28px;
  width: 28px;
  height: 28px;
  font-size: 11px;
  font-weight: bold;
  border-radius: 5px;
  color: ${({ theme }) => theme.secondary.blendToBackground(800)};
  transition:
    background-color 0.1s,
    color 0.1s;

  ${({ isActive }) => !isActive &&
    css `
      &:hover {
        color: ${({ theme }) => theme.secondary.background};
        background-color: ${({ theme }) => theme.secondary.blendToBackground(150)};
      }
    `}

  ${({ isActive }) => isActive &&
    css `
      color: ${({ theme }) => theme.primary.foreground};
      background-color: ${({ theme }) => theme.primary.background};
    `}
`;
export const Pagination = ({ hasNext, hasPrevious, onNext, onPageSizeChange, onPrevious, pageIndex, pageSize, pageSizeOptions = DEFAULT_PAGE_SIZES, }) => {
    const [entriesOpen, setEntriesOpen] = useState(false);
    const visiblePageSizeOptions = useMemo(() => {
        if (pageSizeOptions.includes(pageSize)) {
            return pageSizeOptions.toSorted((a, b) => a - b);
        }
        return [...pageSizeOptions, pageSize].toSorted((a, b) => a - b);
    }, [pageSizeOptions, pageSize]);
    return (React.createElement(Wrapper, null,
        onPageSizeChange && (React.createElement(Dropdown, { options: visiblePageSizeOptions.map((entries) => ({
                label: entries.toString(),
                value: entries,
            })), size: "small", variant: "muted", active: pageSize, customLabel: React.createElement(Entries, { counter: pageSize }, entriesOpen ? React.createElement(Icon.ChevronUp, null) : React.createElement(Icon.ChevronDown, null)), onOpenChange: setEntriesOpen, onChange: onPageSizeChange })),
        React.createElement(PagesWrapper, null,
            React.createElement(Button, { onClick: onPrevious, disabled: !hasPrevious },
                React.createElement(Icon.ChevronLeft, null)),
            React.createElement(Pages, null,
                hasPrevious && React.createElement(Page, { onClick: onPrevious }, pageIndex),
                React.createElement(Page, { isActive: true }, pageIndex + 1),
                hasNext && React.createElement(Page, { onClick: onNext }, pageIndex + 2)),
            React.createElement(Button, { onClick: onNext, disabled: !hasNext },
                React.createElement(Icon.ChevronRight, null)))));
};
//# sourceMappingURL=Pagination.js.map